import { Stack, Text } from "@bookingcom/bui-react";
import React from "react";
export const FilterCount = ({ children, count, attributes, variant }) => {
    return (React.createElement(Stack, { gap: 3, direction: "row" },
        React.createElement(Stack.Item, { grow: true }, children),
        typeof count === "number" ? (React.createElement(Stack.Item, null,
            React.createElement(Text, { attributes: { ...attributes }, variant: variant }, count))) : undefined));
};
